import type { ShotMark } from './roundSession'

const capturedAt='2026-10-25T06:00:00.000Z'
export const teeMetres={
  Blue:[303,331,486,375,156,441,363,195,284,120,350,279,270,159,424,308,308,322],
  White:[300,318,482,350,145,437,353,185,281,115,345,276,262,145,402,304,275,315],
  Red:[292,296,482,325,132,424,349,165,279,110,338,276,258,117,395,300,245,307],
  Yellow:[278,296,468,331,127,416,341,114,274,100,273,252,252,110,362,262,245,288],
} as const
export const yellowMetres=teeMetres.Yellow
export const fourStrokeHoleOneShots:ShotMark[]=[
  {eventId:'demo-hole1-tee',holeNumber:1,club:'Driver',recordedAt:capturedAt,position:{latitude:-27.2305573973,longitude:152.9748389628,accuracyMetres:3,capturedAt,source:'manual'}},
  {eventId:'demo-hole1-drive',holeNumber:1,club:'7 iron',recordedAt:capturedAt,position:{latitude:-27.2296108072,longitude:152.9738190927,accuracyMetres:3,capturedAt,source:'manual'}},
  {eventId:'demo-hole1-green-edge',holeNumber:1,club:'Putter',recordedAt:capturedAt,position:{latitude:-27.2287937245,longitude:152.9729557759,accuracyMetres:3,capturedAt,source:'manual'}},
  {eventId:'demo-hole1-putt-one',holeNumber:1,club:'Putter',recordedAt:capturedAt,position:{latitude:-27.2287387245,longitude:152.9729157759,accuracyMetres:3,capturedAt,source:'manual'}},
  {eventId:'demo-hole1-cup',holeNumber:1,club:'Putter',recordedAt:capturedAt,position:{latitude:-27.2287137245,longitude:152.9728957759,accuracyMetres:3,capturedAt,source:'manual'}},
]

export type DemoHole={holeNumber:number;par:number;distanceMetres:number;shots:ShotMark[]}

// Deliberately schematic: these coordinates provide stable geometry for replay
// mechanics but are never presented as Pine Rivers survey/GPS data.
export function buildSyntheticDemoHole(holeNumber:number,tee:keyof typeof teeMetres='Yellow'):DemoHole{
  const distanceMetres=teeMetres[tee][holeNumber-1]
  const par=distanceMetres>=410?5:distanceMetres>=220?4:3
  const longShots=Math.max(1,par-2)
  // Keep the illustrative overlay in the course overview viewport so the user
  // retains map context. It is explicitly not claimed as surveyed hole geometry.
  const baseLat=-27.2312+(holeNumber%3)*.00004,baseLng=152.9738+(holeNumber%4)*.00004
  const playableMetres=Math.max(1,distanceMetres-8)
  const longSegments=longShots===1?[playableMetres]:longShots===2?[playableMetres*.62,playableMetres*.38]:[playableMetres*.48,playableMetres*.32,playableMetres*.20]
  const segmentMetres=[...longSegments,7,1]
  const cumulative=[0]
  segmentMetres.forEach(value=>cumulative.push(cumulative[cumulative.length-1]+value))
  const points=cumulative.map(metres=>({latitude:baseLat+metres/111320,longitude:baseLng}))
  const shots:ShotMark[]=points.map((point,index)=>{
    const club=index<longShots?(index===0?(par===3?'6 iron':'Driver'):(holeNumber===1?'7 iron':par===5?'5 iron':'8 iron')):'Putter'
    return {eventId:`demo-h${holeNumber}-p${index}`,holeNumber,club,recordedAt:capturedAt,position:{...point,accuracyMetres:3,capturedAt,source:'manual'}}
  })
  return {holeNumber,par,distanceMetres,shots}
}
